import { Flex } from 'antd';
import { useCallback } from 'react';
import { BodyContainer } from '../../../../elements';
import { ShipmentListHook } from '../../../../hooks';
import { useSecondaryHeader } from '../../../../hooks/useSecondaryHeader';
import { InboundShipmentTable } from '../../../../page-components/shipments/inbound/InboundShipmentTable';
import { InboundListToolbar } from '../../../../page-components/shipments/inbound/inbound-list-toolbar';

export function InboundShipmentListScreen() {
  const { data, totalData, loading, filter, filterChanged, pageChanged, setSearch } =
    ShipmentListHook();

  const onSearchChange = useCallback(value => setSearch(value), [setSearch]);

  useSecondaryHeader(
    () => (
      <Flex align="center" style={{ width: '100%' }}>
        <InboundListToolbar search={filter.search} onSearchChange={onSearchChange} />
      </Flex>
    ),
    [filter.search, onSearchChange],
  );

  return (
    <BodyContainer className="no-header">
      <InboundShipmentTable
        data={data}
        loading={loading}
        totalData={totalData}
        filter={filter}
        pageChanged={pageChanged}
        filterChanged={filterChanged}
      />
    </BodyContainer>
  );
}
